import { DesignSystemButton, type IconButtonProps } from '@mathflat/design-system-2024'
import clsx from 'clsx'
import { forwardRef } from 'react'

import { Icon } from '@/component/atoms/Icon'
import type * as icons from '@/component/atoms/Icon/svg/index'

import { iconButtonStyle } from './IconButton.style'

type Props = {
  icon: keyof typeof icons
}

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps & Props>((props, ref) => {
  const { icon, size, variant, ...rest } = props

  const buttonClassName = clsx('button', `button-${size}`, `button-${variant}`)

  return (
    <DesignSystemButton
      css={iconButtonStyle}
      className={buttonClassName}
      size={size}
      ref={ref}
      {...rest}
    >
      <Icon name={icon} />
    </DesignSystemButton>
  )
})

IconButton.displayName = 'IconButton'
export default IconButton
